import React from 'react';
import { TimelinePreview } from './TimelinePreview';
import { BinManager } from './BinManager';
import { FileMenuBar } from './FileMenuBar';

interface StudioLayoutProps {
    header: React.ReactNode;
    sidebar: React.ReactNode;
    timeline: React.ReactNode;
    mainArea: React.ReactNode;
    toolbar: React.ReactNode;
    sidebarVisible?: boolean;
    timelineVisible?: boolean;
    toolbarVisible?: boolean;
}

export const StudioLayout: React.FC<StudioLayoutProps> = ({
    sidebar,
    timeline,
    mainArea,
    toolbar,
    header,
    sidebarVisible = true,
    timelineVisible = true,
    toolbarVisible = true
}) => {
    return (
        <div className="flex flex-col h-full bg-[#111] text-gray-200 overflow-hidden font-sans selection:bg-indigo-500/30">
            {/* Header / Menu Bar */}
            <div className="shrink-0 z-50 bg-[#1e1e1e] border-b border-[#333]">
                {header}
            </div>

            {/* Main Workspace */}
            <div className="flex flex-1 overflow-hidden relative">
                {/* Left Sidebar (Bins / Tools) */}
                {sidebar && (
                    <div
                        className="shrink-0 z-30 flex"
                        style={{ display: sidebarVisible ? 'flex' : 'none' }}
                    >
                        {sidebar}
                    </div>
                )}

                {/* Center / Right Area */}
                <div className="flex-1 flex flex-col min-w-0 bg-[#0a0a0a] relative">
                    {/* Toolbar */}
                    {toolbar && (
                        <div
                            className="h-12 border-b border-[#333] bg-[#161616] flex items-center px-4 shrink-0 z-20 justify-between"
                            style={{ display: toolbarVisible ? 'flex' : 'none' }}
                        >
                            {toolbar}
                        </div>
                    )}


                    {/* Viewport / Canvas */}
                    <div className="flex-1 relative overflow-hidden bg-[#050505]">
                        {mainArea}
                    </div>

                    {/* Timeline (Bottom) */}
                    {timeline && (
                        <div
                            className="h-[35vh] min-h-[200px] border-t border-[#333] bg-[#111] shrink-0 z-10 relative flex flex-col"
                            style={{ display: timelineVisible ? 'flex' : 'none' }}
                        >
                            {timeline}
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};
